import { Injectable } from "@angular/core";
import { PageResolver } from "./page-resolver";
import { ResolutionConfig } from "./resolution-config";
import { Observable, combineLatest } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class ResolutionService {
    constructor(private pageResolver: PageResolver) {}

    public setCorrelationId(receivedCorrelationId: string) {
        this.pageResolver.ReceivedCorrelationId = receivedCorrelationId;
    }

    public clearPageCorrelationIds() {
        this.pageResolver.clearPageCorrelationIds();
    }

    public addCorrelationIdInPageState(correlationId: string) {
        this.pageResolver.addCorrelationId(correlationId);
    }

    public resolve(config: ResolutionConfig): boolean {
        const conditions: boolean[] = [];

        if (config.resolveByPage) {
            conditions.push(this.pageResolver.resolve());
        }

        return conditions.every((result) => result);
    }
}
